document.addEventListener('DOMContentLoaded', function() {
	gsap.registerPlugin(ScrollTrigger);

	let scroll;

	const body = document.body;
	const select = (e) => document.querySelector(e);
	const selectAll = (e) => document.querySelectorAll(e);
	const loader = select('.js-loader');
	const scroller = select('[data-scroll-container]');
	const cursorinner = select('.cursor');

	// show loader on page load
	gsap.set(loader, {autoAlpha: 1});

	initPageTransitions();
	get_works_more();

	function pageTransitionIn({container}) {
		// timeline to stretch the loader over the whole screen
		const tl = gsap.timeline({
			defaults: {
				duration: 1,
				ease: 'power2.inOut'
			}
		});
		tl
			.fromTo(loader, { yPercent: -100 }, {yPercent: 0 })
			.to(container, { y: 150}, 0);
		return tl;
	}

	function pageTransitionOut({container}) {
		stopMatrixAnimations({
			animations: matrixAnimations,
			debug: 'on unload'
		})

		// timeline to move loader away down
		const tl = gsap.timeline({
			defaults: {
				duration: 0,
				ease: 'power2.inOut'
			},
			onComplete: () => initScript()
		});
		tl
			.to(loader, { yPercent: 100 })
			.from(container, { y: 150}, 0);
		return tl;
	}

	function initPageTransitions() {

		// do something before the transition starts
		barba.hooks.before(() => {
			document.documentElement.classList.add('is-transitioning');
			body.className = '';
			cursorinner.classList.remove('hover-text', 'hover-text-link');
			cursorinner.innerHTML = "";
		});

		// do something after the transition finishes
		barba.hooks.after(() => {
			document.documentElement.classList.remove('is-transitioning');
			document.documentElement.classList.remove('has-gsap-horizontal');

			get_works_more();
			setSliderContact();
			setSliderCarrer();
		});

		// scroll to the top of the page
		barba.hooks.enter(() => {
			window.scrollTo(0, 0);
		});

		barba.init({
			sync: true,
			cacheIgnore: true,
			preventRunning: false,
			//debug: true,
			timeout: 7000,
            prevent: (data) => {
                return true;
            },
			transitions: [{
				name: 'overlay-transition',
				once(data) {
					// do something once on the initial page load
					initSmoothScroll(data.next.container);
					initShowHideHeader();
					initLoader();
				},
				async leave(data) {

					location.reload()

					// animate loading screen in
					const header = select(".header");
					header.classList.add('hidden');

					body.classList.remove('opened-menu');
					pageTransitionIn(data.current);
					await delay(1000);
					header.style.transform='';
					data.current.container.remove();
				},
				async enter(data) {
					// animate loading screen away
					pageTransitionOut(data.next);
					resetCursor(cursorinner, 'cursor');
				},
				async beforeEnter(data) {
					ScrollTrigger.getAll().forEach(t => t.kill());
					scroll.destroy();
					initSmoothScroll(data.next.container);
					await delay(10);
					initShowHideHeader();
				},
			}]
		});

		function initSmoothScroll(container) {
			const scrollContainer = container.querySelector('[data-scroll-container]');

			scroll = new LocomotiveScroll({
				el: scrollContainer,
				smooth: true,
				tablet: {
					smooth: true
				},
				getSpeed: true,
				getDirection: true,
				multiplier: 0.8,
				firefoxMultiplier:80
			});

			scroll.on("scroll", ScrollTrigger.update);

			scroll.on("scroll", (position) => {
				if ((position.scroll.y) > 50) {
					document.body.classList.add("scrolled");
				} else {
					document.body.classList.remove("scrolled");
				}
			});

			ScrollTrigger.scrollerProxy(scrollContainer, {
				scrollTop(value) {
					return arguments.length ? scroll.scrollTo(value, 0, 0) : scroll.scroll.instance.scroll.y;
				}, // we don't have to define a scrollLeft because we're only scrolling vertically.
				getBoundingClientRect() {
					return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
				},
				pinType: scrollContainer.style.transform ? "transform" : "fixed"
			});

			const scrollbar = selectAll('.c-scrollbar');

			if(scrollbar.length > 1) {
				scrollbar[0].remove();
			}

			// each time the window updates, we should refresh ScrollTrigger and then update LocomotiveScroll.
			ScrollTrigger.addEventListener('refresh', () => {
				scroll.update()
			});

			// after everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
			ScrollTrigger.refresh();
		}
	}

	function initLoader() {

		const tlLoaderIn = gsap.timeline({
			id: 'tlLoaderIn',
			defaults: {
				duration: 1.1,
				ease: 'power2.out'
			},
			onComplete: () => initScript()
		});

		// tlLoaderIn
		//.set(loaderContent, {autoAlpha: 1})

		const tlLoaderOut = gsap.timeline({
			id: 'tlLoaderOut',
			defaults: {
				duration: 1.2,
				ease: 'power2.inOut'
			},
			delay: 1
		});

		tlLoaderOut
			.to(loader, {yPercent: -100}, 0.2)

		const tlLoader = gsap.timeline();
		tlLoader
			.add(tlLoaderIn)
			.add(tlLoaderOut);

	}

	function delay(n) {
		n = n || 2000;
		return new Promise((done) => {
			setTimeout(() => {
				done();
			}, n);
		});
	}

	/**
	 * Fire all scripts on page load
	 */
	function initScript() {

		let deviceWidth = window.matchMedia("(max-width: 767px)");

		if (deviceWidth.matches) {
			const matrAnim = document.querySelectorAll('.matrix-animation.primary, .matrix-animation.hover, .matrix-animation.home-project__animation');

			matrAnim.forEach(box => {
				box.remove();
			});
		}
		document.body.classList.remove('is-loading');
		initImageParallax();

		function HideBrowserScrollbar() {
			let scrollHide = document.createElement("style");
			scrollHide.innerHTML = `body::-webkit-scrollbar {display: none;}`;
			document.head.appendChild(scrollHide);
		}
		HideBrowserScrollbar();

		//Intro Page Animation
		const canvases = document.querySelectorAll('.matrix-animation:not(.intro__animation)');

		const getRandomInt = (min, max) =>
			Math.floor(Math.random() * (max - min) + min);

		const getChar = () => {
			const generate = () =>
				String.fromCharCode(getRandomInt(33, 96));
			const restricted = ['#', '@', '%', '&', '^', '<', '>', '+'];

			let char = generate();
			while (restricted.includes(char)) {
				char = '¦';
			}
			return char;
		};

		const animateMatrix = (canvas) => {
			let ctx = canvas.getContext('2d');

			const elInterval = +canvas.dataset.interval;
			const elBg = canvas.dataset.bg;
			const elSize = canvas.dataset.size;
			const elColor = canvas.dataset.color;
			const sizeRestriction = canvas.dataset.sizeRestriction;
			const symbolDistance = +canvas.dataset.distance || 15;

			if (sizeRestriction) {
				canvas.height = window.innerHeight / sizeRestriction;
				canvas.width = window.innerWidth / sizeRestriction;
			} else {
				canvas.height = window.innerHeight;
				canvas.width = window.innerWidth;
			}

			// Setting up the letters
			let dropCount = Math.floor(canvas.width / 5);
			let drops = [];

			for(let i = 0; i < dropCount; i++){
				drops.push({x: i * 5, y: Math.ceil(Math.random() * 60) * -25})
			}

			const drop = () => {
				ctx.fillStyle = elBg;
				ctx.fillRect(0, 0, canvas.width, canvas.height);

				for(let i = 0; i < dropCount; i++) {
					let text = getChar();

					if(drops[i].y > canvas.height) {
						drops[i].y = -symbolDistance;
					}
					drops[i].y += symbolDistance;

					const [, fontType] = ctx.font.split(' ');
					ctx.font = `bold ${elSize}px ${fontType}`;

					ctx.fillStyle = elColor;
					ctx.fillText(text, drops[i].x, drops[i].y);
				}
			};

			const intervalId = setInterval(drop, elInterval);

			matrixAnimations.push({
				$el: canvas,
				intervalId: intervalId,
			});
		};

		canvases.forEach(animateMatrix);


		if (document.getElementById('intro')) {

			function startWorkVideos() {

				let videoItems = document.querySelectorAll('.autoplay-video-item');

				videoItems.forEach((video) => {
					video.play();
				});
			}

			// Finish Loading
			function finishIntro () {
				if (intro.classList.contains("page-404")) return false;

				if (intro.querySelector(".intro__block") !==null) intro.querySelector(".intro__block").classList.add('finish');


				intro.classList.add('finish');

				setTimeout(function() {

					stopMatrixAnimations({
						animations: matrixAnimations,
						targetClass: 'intro__animation',
						debug: 'on load'
					});

					intro.remove();

					startWorkVideos();
				}, 1600);
			}
			setTimeout(function() {
				if (intro.querySelector(".rocket-intro-new") !==null) intro.querySelector(".rocket-intro-new").classList.add('rocket-intro');
			}, 500);

			setTimeout(finishIntro, 3700);

			setTimeout(function() {
				body.classList.remove('opened-intro-animation');
				document.querySelector(".header").classList.remove('hidden');

				document.querySelector(".page-title")?.classList.add('is-inview');
				document.querySelector(".section-title")?.classList.add('is-inview');
				document.querySelector(".sub-title-primary")?.classList.add('is-inview');
				document.querySelector(".intro-delay-5")?.classList.add('is-inview');
				document.querySelector(".scroll-to")?.classList.add('is-inview');

				scroll.update();
				initShowHideHeader()
			},5000);

			setTimeout(function() {
				document.querySelector(".primary-text-block")?.classList.add('is-inview');
			},5300);

			setTimeout(function() {
				document.querySelector(".intro-delay-55")?.classList.add('is-inview');
				ScrollTrigger.refresh();
			},5500);
		}

		// splitting plugin
		const splitLines = document.querySelectorAll('.split-lines');
		Splitting({
			target: splitLines,
			by: 'lines',
		});

		const splitWords = document.querySelectorAll('.word');
		Splitting({
			target: splitWords,
		});

		// animation
		document.querySelectorAll('.fade-right').forEach(function(fadeRight) {
			const delay = fadeRight.getAttribute('data-delay');
			let duration = fadeRight.getAttribute('data-duration');
			const clone = fadeRight.innerHTML;
			if(duration === null) {
				duration = 1;
			}
			fadeRight.innerHTML = '<span data-scroll style="--delay:'+delay+'s; --duration:'+duration+'s">' + clone + '</span>';
		});

		document.querySelectorAll('.fade-top').forEach(function(fadeRight) {
			const delay = fadeRight.getAttribute('data-delay');
			let duration = fadeRight.getAttribute('data-duration');
			const clone = fadeRight.innerHTML;
			if(duration === null) {
				duration = 1;
			}
			fadeRight.innerHTML = '<span data-scroll style="--delay:'+delay+'s; --duration:'+duration+'s">' + clone + '</span>';
		});

		document.querySelectorAll('.fade-left').forEach(function(fadeRight) {
			const delay = fadeRight.getAttribute('data-delay');
			let duration = fadeRight.getAttribute('data-duration');
			const clone = fadeRight.innerHTML;
			if(duration === null) {
				duration = 1;
			}
			fadeRight.innerHTML = '<span data-scroll style="--delay:'+delay+'s; --duration:'+duration+'s">' + clone + '</span>';
		});

		document.querySelectorAll('.fade-in').forEach(function(fadeRight) {
			const delay = fadeRight.getAttribute('data-delay');
			let duration = fadeRight.getAttribute('data-duration');
			const clone = fadeRight.innerHTML;
			if(duration === null) {
				duration = 1;
			}
			fadeRight.innerHTML = '<span data-scroll style="--delay:'+delay+'s; --duration:'+duration+'s">' + clone + '</span>';
		});

		const scrollbar = selectAll('.c-scrollbar');

		if (scrollbar.length > 1) {
			scrollbar[0].remove();
		}

		const postIntroBlock = document.querySelector('.post-intro__block');
		if (postIntroBlock) {
			const postTitle = postIntroBlock.querySelector('.post-intro__block .section-title');
			const postTitleWrap = postIntroBlock.querySelector('.post-intro__block__desc');
			const postTitleLanght = postTitle.style.cssText.replace(/[_\W]+/g, "");
			const postTitleLanght2 = postTitleLanght.slice(-6);
			postTitleWrap.classList.add(postTitleLanght2);
			console.log(postTitleLanght2)
		}

		// Accordoin
		const accordion = select(".home-accordion__wrapper");

		if (accordion) {
			const title = select('.home-accordion__block:first-child .course-accordion ');
			const coursePanel = select(".home-accordion__block:first-child .course-panel");
			coursePanel.style.maxHeight = coursePanel.scrollHeight + "px";
			//adds the 'active' addition to the css.
			title.classList.add("active");
		}

		//this is the button
		var acc = document.getElementsByClassName("course-accordion");
		var i;

		for (i = 0; i < acc.length; i++) {
			//when one of the buttons are clicked run this function
			acc[i].onclick = function() {
				event.preventDefault();
				//variables
				var panel = this.nextElementSibling;
				var coursePanel = document.getElementsByClassName("course-panel");
				var courseAccordionActive = document.getElementsByClassName("course-accordion active");

				/*if pannel is already open - minimize*/
				if (panel.style.maxHeight){
					//minifies current pannel if already open
					panel.style.maxHeight = null;
					//removes the 'active' class as toggle didnt work on browsers minus chrome
					this.classList.remove("active");
					if (deviceDesktop.matches) {
						cursorinner.classList.remove('hover-text-minus');
						cursorinner.classList.add('hover-text-plus');
					}

				} else { //pannel isnt open...
					//goes through the buttons and removes the 'active' css (+ and -)
					for (var ii = 0; ii < courseAccordionActive.length; ii++) {
						courseAccordionActive[ii].classList.remove("active");
					}
					//Goes through and removes 'activ' from the css, also minifies any 'panels' that might be open
					for (var iii = 0; iii < coursePanel.length; iii++) {
						this.classList.remove("active");
						coursePanel[iii].style.maxHeight = null;
					}
					//opens the specified pannel
					panel.style.maxHeight = panel.scrollHeight + "px";
					//adds the 'active' addition to the css.
					this.classList.add("active");
					if (deviceDesktop.matches) {
						cursorinner.classList.remove('hover-text-plus');
						cursorinner.classList.add('hover-text-minus');
					}
				}
				setTimeout(function() {
					scroll.update();
				}, 500);
			}//closing to the acc onclick function
		}//closing to the for loop.

		// Height
		function setHeight() {
			var fullH = document.querySelectorAll('.full-height');
			fullH.forEach((el) => {
				el.style.height = window.innerHeight + "px";
			});
		}

		setTimeout(function(){
			setHeight();
		},1000);

		function setBodyClass() {
			var viewportWidth= window.innerWidth;
			var viewportHeight = window.innerHeight;

			if(viewportHeight/viewportWidth < 0.6) {
				document.documentElement.classList.add('smallHeight');
			}
			else {
				document.documentElement.classList.remove('smallHeight');
			}
		}

		var videoHoverEl = select('.home-intro__link video');
		if (videoHoverEl) {
			var videoHover = select('.home-intro__link');
			videoHover.addEventListener("pointerenter",()=>{
				videoHoverEl.play();
			});
			videoHover.addEventListener("pointerleave",()=>{
				videoHoverEl.pause();
			});
		}

		// Show/Hide intro-project__block img
		if (document.getElementById('intro-project__block')) {
			var ipLink = document.querySelectorAll('.intro-project__title a');
			ipLink.forEach((el) => {
				el.addEventListener("pointerenter",()=>{
					let image;
					if ('img' in el.dataset) {
						url = el.dataset.img;
						image = new Image();
					} else if ('video' in el.dataset) {
						url = el.dataset.video;
						image = document.createElement("video");

					}
					image.src = url;
					image.classList.add('intro-project__media');
					el.closest('li').appendChild(image);
					const t1 = gsap.timeline();
					t1.to('.intro-project__media', {
						duration: 0.5,
						autoAlpha: 1
					});
					if ('video' in el.dataset) {
						image.muted = true;
						image.play();
					}
				});
				el.addEventListener("pointerleave",()=>{
					const tl = gsap.timeline();
					tl.to('.intro-project__media', {
						duration: 0.5,
						autoAlpha: 0
					});
					document.querySelector('.intro-project__media').remove();
				});
				el.addEventListener("mousemove", moveImage);
			});

			function moveImage(e) {
				let xpos = e.clientX;
				const tl = gsap.timeline();
				tl.to('.intro-project__media', {
					x: xpos,
					y: '-50%'
				});
			}
		}

		// Logo Slider
		function marqueeLogo(selector, speed) {
			const parentSelector = document.querySelector(selector);
			if (parentSelector) {
				let i = 0;
				const firstElement = parentSelector.children[0];
				const secondElement = firstElement.cloneNode(true);
				parentSelector.appendChild(secondElement);

				function animateLogo() {
					firstElement.style.transform = 'translateX(-'+i+'px)';
					secondElement.style.transform = 'translateX(-'+i+'px)';
					if (i > firstElement.clientWidth) {
						i = 0;
					}
					i = i + speed;

					requestAnimationFrame(animateLogo);
				}
				requestAnimationFrame(animateLogo);
			}
		}
		marqueeLogo('.partner__slider', 0.3)

		/*
		mySwiper1 = new Swiper('.partner__slider', {
			grabCursor: false,
			loop: true,
			slidesPerView: 1,
			shortSwipes: false,
			longSwipes: false,
			allowTouchMove: false,
			autoplay: {
				delay: 0,
			},
			freeMode: true,
			speed: 15000,
		});

		 */

		mySwiper2 = new Swiper(".dignity-slide", {
			spaceBetween: 30,
			effect: "fade",
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			on: {
				init: function (swiper) {
					let index_currentSlide = swiper.realIndex;
					let currentSlide = swiper.slides[index_currentSlide];
					if ( window.innerWidth > 991 ) {
						setSliderFotterBtnData(currentSlide);
					}
				},
				resize: function (swiper) {
					let index_currentSlide = swiper.realIndex;
					let currentSlide = swiper.slides[index_currentSlide];
					if ( window.innerWidth > 991 ) {
						setSliderFotterBtnData(currentSlide);
					}
				},
			},
		});
		mySwiper2.on('slideChange', function (swiper) {
			let index_currentSlide = swiper.realIndex;
			let currentSlide = swiper.slides[index_currentSlide];
			if ( window.innerWidth > 991 ) {
				setSliderFotterBtnData(currentSlide);
			}
		});


		function setSliderFotterBtnData(slide) {
			let footerLink = document.querySelector('.dignity__footer-link');
			let slideLink = slide.getAttribute('data-btn-link');
			let slideTitle = slide.getAttribute('data-btn-title');

			if (footerLink !== null && slideLink && slideTitle) {
				footerLink.setAttribute('href', slideLink);
				footerLink.innerHTML = slideTitle;
			}
		}

		function loadMedia() {
			let mediaObject = document.querySelectorAll('.media-object');
			mediaObject.forEach((el) => {
				el.innerHTML = ""
			});
			let deviceMinWidth = window.matchMedia("(min-width: 768px)");
			if (deviceMinWidth.matches) {
				mediaObject.forEach((el) => {
					let mediaSourse;
					let url;
					if ('img' in el.dataset) {
						url = el.dataset.img;
						mediaSourse = new Image();
						mediaSourse.src = url;
					}
					else if ('video' in el.dataset) {
						url = el.dataset.video;
						mediaSourse = document.createElement('video');
						if ('videoLoop' in el.dataset) mediaSourse.loop = true;
						if (el.dataset.videoWebm) {
							let sourceWebm = document.createElement('source');
							sourceWebm.src = el.dataset.videoWebm;
							sourceWebm.type = "video/webm";
							mediaSourse.appendChild(sourceWebm);
						}
						let source = document.createElement('source');
						source.src = url;
						source.type = "video/mp4";
						mediaSourse.appendChild(source);
					}
					el.appendChild(mediaSourse);
					if ('video' in el.dataset) {
						setTimeout(function() {
							mediaSourse.muted = true;
							mediaSourse.play();
						}, 4600);
					}
				});
			}
		}
		loadMedia();

		const workGridItem = select('.work-grid__item');
		if (workGridItem) {
			const workVideo = workGridItem.querySelectorAll('.work-grid__item video');
			workVideo.forEach((el) => {
				setTimeout(function() {
					el.play();
				}, 300);
			});
		}


		if (deviceWidth.matches) {
			setTimeout(function() {
				var offsetEl = document.querySelectorAll('.dignity__head, .partner__head');

				offsetEl.forEach(function(el){
					el.setAttribute('data-scroll-offset', '10%');
				});
			},100);
		}
		else {
			setBodyClass();
		}

		// Custom cursor
		let deviceDesktop = window.matchMedia("(min-width: 1200px)");

		if (deviceDesktop.matches) {
			initCursor();
		}

		// Splitting
		Splitting();

		ScrollTrigger.refresh();

		// Scripts which runs at window scroll
		/*window.addEventListener("scroll", function(event) {
            var scrollTop = this.scrollY;
            console.log(scrollTop);

            if ((position.scroll.y) > 50) {
                document.querySelector('.header').classList.remove('is--large');
                document.querySelector('.header').classList.add('is--small');
            } else {
                document.querySelector('.header').classList.remove('is--small');
                document.querySelector('.header').classList.add('is--large');
            }
        }, false);*/
		//

		const introVideoContainer = document.getElementById('intro-video');
		if (introVideoContainer) {
			const introVideo = introVideoContainer.querySelector('#intro-video video');

			document.querySelector('.home-intro__link').addEventListener('click', () => {
				introVideo.play();
			});

			introVideoContainer.querySelector('#intro-video .js-modal__close').addEventListener('click', () => {
				introVideo.pause();
			});
		}

		// Show/Hide checkbox filter
		if (document.getElementById('blog-filter')) {
			const filters = document.querySelectorAll('.filter-wrapper');
			for (let i = 0; i < filters.length; i++) {
				const button = filters[i];
				const banner = filters[i].querySelector('.checkbox-group');
				const filter = filters[i].querySelector('.filter__tags');

				button.addEventListener('click', () => {
					if (body.classList.contains('active-filter')) {
						body.classList.remove('active-filter');
						button.classList.remove('active');
					}
					else {
						body.classList.add('active-filter');
						button.classList.add('active');
					}
				});

				// Close when user click outside
				document.body.addEventListener('mousedown', (e) => {
					let isClickInsideButton = button.contains(e.target);
					let isClickInsideBanner = banner.contains(e.target);
					let isClickInsideFilter = filter.contains(e.target);

					if (!isClickInsideButton && !isClickInsideBanner && !isClickInsideFilter) {
						body.classList.remove('active-filter');
						button.classList.remove('active');
					}
				});
			}

			/** Search handlers */
			let $serchBlogbtn = document.getElementById('blog-filter-search-btn');
			if ($serchBlogbtn !== null) {
				$serchBlogbtn.addEventListener('click', (e) => {
					e.preventDefault();
					getPosts();
				});
			}

			let search = document.querySelector('[name="search"]');
			if (search) {
				search.addEventListener('keydown', function(e){
					if (e.keyCode === 13) {
						getPosts();
					}
				});
			}

			function getPosts() {
				let $form = document.getElementById('blog-filter-form');
				var $dataAttr = $form.getAttribute('data-attr')
				var $blogOverflow = document.getElementById('blog-overflow');
				if ($form !== null) {
					const formData = new FormData($form);

					if($dataAttr === 'resource'){
						formData.append('action', 'get_resource_list');
					}else{
						formData.append('action', 'get_post_list');
					}

					formData.append('nonce', themeJsVars.nonce);

					fetch(themeJsVars.ajaxurl,{
						method: 'POST',
						body: formData,
						credentials: 'same-origin'
					})
						.then(response => response.json())
						.then(data => {
							if ( data.success ) {
								$blogOverflow.innerHTML = data.html;
								window.dispatchEvent(new Event('resize'));
							}

							/**
							 * Update hover state
							 */
							resetCursor(cursorinner, 'cursor');
							setTimeout(() => {
								initCursor();
							}, 250);
						})
						.catch(err => console.log(err));
				}
			}

			// Checkbox Filter
			function addEvents() {
				const checkboxTag = document.querySelectorAll('.checkbox-tag .icon-close');

				checkboxTag.forEach(el => {
					el.addEventListener('click', () => {
						const elId = el.dataset.id;
						el.parentNode.remove();
						document.getElementById(elId).checked = false;
						//el.stopPropagation();
						getPosts();
					});
				});

				const boxes = document.querySelectorAll('.filter__tags');
				if (boxes.length) {
					for (const box of boxes) {
						const boxH = box.clientHeight;
						if (boxH < 1) {
							box.classList.remove('active');
						}
						else {
							box.classList.add('active');
						}
					}
				}
			}
			addEvents();

			const checkbox = document.querySelectorAll('input[name="check[]"], input[name="sort[]"]');
			checkbox.forEach(function(checkitem) {
				const dataValue = checkitem.id;
				const itemname = checkitem.getAttribute("data-name");
				const filterWrapper = checkitem.closest('.filter-wrapper');
				const box = filterWrapper.querySelector('#filter__tags');

				checkitem.addEventListener('change', (e) => {
					if (e.target.checked === true) {
						const el = document.createElement('span');
						const elI = document.createElement('i');

						el.setAttribute('id', 'data-' + dataValue);
						elI.setAttribute('data-id', dataValue);
						el.textContent = itemname;
						el.classList.add('checkbox-tag');
						elI.classList.add('icon-close');

						el.appendChild(elI);

						if (checkitem.classList.contains('sort')) {
							box.innerHTML = "";

							/** Unchecking checboxes except `this` */
							const local_inputs = filterWrapper.querySelectorAll('input[name="check[]"]');
							local_inputs.forEach(function(item) {
								if (item.value !== checkitem.value) {
									item.checked = false;
								}
							});
							const local_inputs_sort = filterWrapper.querySelectorAll('input[name="sort[]"]');
							local_inputs_sort.forEach(function(item) {
								if (item.value !== checkitem.value) {
									item.checked = false;
								}
							});

                            box.appendChild(el);
                        } else if (checkitem.classList.contains('contents')) {
                            box.innerHTML = "";
                            const local_inputs = filterWrapper.querySelectorAll('input[name="check[]"]');
                            local_inputs.forEach(function(item) {
                                item.checked = false;
                            });

                            const anchor = checkitem.getAttribute('data-anchor');
                            const isAnchor = document.querySelector(anchor);

							if (isAnchor) scroll.scrollTo(anchor);

							checkitem.closest('.filter-wrapper').classList.remove('active');

						} else {
							box.appendChild(el);
						}

						addEvents();
					}
					if (e.target.checked === false) {
						const target = document.getElementById('data-' + dataValue);
						if (target) target.remove();
					}
					getPosts();
				});
			});

			document.addEventListener('click', function (event) {
				if (!event.target.closest('.icon-close')) return;
				addEvents();
			});
		}

		var wobbleElements = document.querySelectorAll('.typing');
		let timers = [];

		wobbleElements.forEach((el) => {
			let animationName;

			el.addEventListener('mouseover', () => {
				if(!el.classList.contains('animating') && !el.classList.contains('mouseover')) {

					el.classList.add('animating','mouseover');

					var letters = el.innerText.split('');
					const timerId = setTimeout(() => {
							el.classList.remove('animating');
						},
						(letters.length + 1) * 50
					);
					timers.push(timerId);

					animationName = el.dataset.animation;
					if(!animationName) { animationName = "sheen"; }

					el.innerText = '';

					letters.forEach((letter) => {
						if(letter == " ") {
							letter = "&nbsp;";
						}
						el.innerHTML += '<span class="letter">'+letter+'</span>';
					});

					let letterElements = el.querySelectorAll('.letter');
					letterElements.forEach((letter, i) => {
						const timerId_1 = setTimeout(() => {
							letter.classList.add(animationName);
						}, 100 + (i * 50));

						const timerId_2 = setTimeout(() => {
							letter.classList.remove(animationName);
						}, 1000);

						timers.push(...[timerId_1, timerId_2]);
					});
				}
			});

			el.addEventListener('mouseout', function(){
				el.classList.remove('mouseover');
				el.classList.remove('animating');

				timers.forEach((t) => {
					clearTimeout(t);
				})
				timers = [];

				let letterElements = el.querySelectorAll('.letter');
				letterElements.forEach((letter) => {
					letter.classList.remove(animationName)
				});
			});
		});

		// Content Fade Elements
		var contentEl = document.querySelectorAll('.content p, .content h1, .content h2, .content h3, .content h4, .content h5, .content h6, .content picture');

		contentEl.forEach(function(el){
			el.classList.add('fade-in-block');
			el.setAttribute('data-scroll', '');
		});

		setTimeout(function(){
			updateLoco();
		}, 1000);

		/* Latest Project Slider */
		new Swiper(".latestProject", {
			slidesPerView: 1,
			spaceBetween: 30,
			loop: true,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				768: {
					slidesPerView: 3,
					spaceBetween: 23,
					loop: false,
				}
			},
		});

		marqueeInit({
			container: '.marquee__wrap',
			inner: '.marquee__inner'
		});

		/* Modal */
		document.addEventListener('click', modalHandler);

		function modalHandler(evt) {
			const modalBtnOpen = evt.target.closest('.js-modal');
			if (modalBtnOpen) { // open btn click

				const modalSelector = modalBtnOpen.dataset.modal;
				showModal(document.querySelector(modalSelector));
			}

			const modalBtnClose = evt.target.closest('.js-modal__close');
			if (modalBtnClose) { // close btn click
				const modal_window = modalBtnClose.closest('.modal-window');
				if (modal_window) {
					const form = modal_window.querySelector('form');
					const gfield_error_title = modal_window.querySelector('.gform_validation_errors');

					if (gfield_error_title) gfield_error_title.remove();

					if (form) {
						const gfield_error_groups = form.querySelectorAll('.gfield_error');
						const gfield_error_messages = form.querySelectorAll('.gfield_validation_message');

						if (gfield_error_groups.length) {
							for (const group of gfield_error_groups) {
								group.classList.remove('gfield_error');
							}
						}

						if (gfield_error_messages.length) {
							for (const message of gfield_error_messages) {
								message.remove();
							}
						}

						form.reset();
					}
				}

				hideModal(modalBtnClose.closest('.modal__window'));
			}

			if (evt.target.matches('#modal-backdrop')) { // backdrop click
				hideModal(document.querySelector('.modal__window.show'));
			}
		}

		function showModal(modalElem) {
			body.classList.add('modal-show');
			modalElem.classList.add('show');
		}

		function hideModal(modalElem) {
			body.classList.remove('modal-show');
			modalElem.classList.remove('show');
		}

		// Phone Mask //
		[].forEach.call(document.querySelectorAll('[type=\'tel\']'), function (input) {
			let keyCode;
			function mask(event) {
				event.keyCode && (keyCode = event.keyCode);
				let pos = this.selectionStart;
				if (pos < 1) event.preventDefault();
				let matrix = "(___) ___-____",
					i = 0,
					def = matrix.replace(/\D/g, ""),
					val = this.value.replace(/\D/g, ""),
					newValue = matrix.replace(/[_\d]/g, function (a) {
						return i < val.length ? val.charAt(i++) || def.charAt(i) : a;
					});
				i = newValue.indexOf("_");
				if (i != -1) {
					i < 2 && (i = 1);
					newValue = newValue.slice(0, i);
				}
				let reg = matrix.substr(0, this.value.length).replace(/_+/g,
					function (a) {
						return "\\d{1," + a.length + "}";
					}).replace(/[+()]/g, "\\$&");
				reg = new RegExp("^" + reg + "$");
				if (!reg.test(this.value) || this.value.length < 2 || keyCode > 47 && keyCode < 58) this.value = newValue;
				if (event.type == "blur" && this.value.length < 2) this.value = "";
			}

			input.addEventListener("input", mask, false);
			input.addEventListener("focus", mask, false);
			input.addEventListener("blur", mask, false);
			input.addEventListener("keydown", mask, false);
		});

		/* ABOUT PAGE */
		setTimeout(function() {
			function initNumber() {
				// Numbers Animation
				gsap.utils.toArray(".counts").forEach(element => {
					let clean = v => (v + "").replace(/[^\d\.-]/gi, ""), // get rid of anything except numbers and periods
						num = clean(element.getAttribute("data-number")),
						decimals = (num.split(".")[1] || "").length,
						//proxy = {val: parseFloat(clean(element.innerText)) || 0};
						proxy = {val: 0};
					gsap.to(proxy, {
						val: +num,
						duration: 2,
						scrollTrigger: {
							trigger: element,
							scroller: '.wrapper'
						},
						onUpdate: () => element.innerText = formatNumber(proxy.val, decimals)
					});
				});
			}

			initNumber();

			function formatNumber(value, decimals) {
				let s = (+value).toLocaleString('en-US').split(".");
				return decimals ? s[0] + "." + ((s[1] || "") + "00000000").substr(0, decimals) : s[0];
			}

			// Hero animation
			const aboutIntro = document.querySelector('.about-hero');
			if ( aboutIntro ) {
				const heroMatchMedia = gsap.matchMedia();

				heroMatchMedia.add("(min-width: 500px)", () => {
					gsap.to('.about-hero__title', {
						x: '-49vw',
						duration: 2,
						ease: 'Power4.easeInOut',
					})
				});

				heroMatchMedia.add("(max-width: 499px)", () => {
					gsap.set('.about-hero__col-right', {
						zIndex: -1,
					})
					gsap.set('.about-hero__title', {
						x: '100vw',
						zIndex: 3
					})

					gsap.to('.about-hero__title', {
						x: 0,
						duration: 2,
						ease: 'Power4.easeInOut',
					})
					gsap.set('.about-hero__col-right', {
						zIndex: 2,
						delay: 2
					})
					gsap.to('.about-hero__title', {
						x: '-100vw',
						duration: 2,
						delay: 4,
						ease: 'Power4.easeInOut',
					})
				});
			}

			// Marquee scroll-based
			if (document.getElementById('rocket-marquee')) {
				const rocketMatchMedia = gsap.matchMedia();
				rocketMatchMedia.add("(min-width: 500px)", () => {
					gsap.from('#rocket-marquee', {
						x: -1000,
						scrollTrigger: {
							trigger: ".about-hero",
							scroller: '.wrapper',
							start: "top top",
							end: window.innerHeight * 1.5,
							ease: 'Power4.easeInOut',
							scrub: 2,
						}
					})
				});
				rocketMatchMedia.add("(max-width: 499px)", () => {
					gsap.from('#rocket-marquee', {
						x: -200,
						scrollTrigger: {
							trigger: ".rocket-marquee",
							scroller: '.wrapper',
							start: '-50%',
							ease: 'Power4.easeInOut',
							scrub: 2,
						}
					})
				});
			}

			// Team animation
			const aboutTeam = document.querySelector('.team');
			if ( aboutTeam && window.innerWidth > 1199 ) {
				const teamMatchMedia = gsap.matchMedia();

				teamMatchMedia.add("(min-width: 1199px)", () => {
					const teamInner = document.querySelector('.team__inner');
					const allChildren = teamInner.getElementsByTagName('div').length;

					gsap.to(teamInner, {
						x: () => -(teamInner.scrollWidth - window.innerWidth),
						ease: 'none', // IMPORTANT
						scrollTrigger: {
							trigger: '.team',
							scroller: '.wrapper',
							end: () => `+=${teamInner.offsetWidth / allChildren}`,
							scrub: 1,
							pin: true,
							anticipatePin: 1,
							invalidateOnRefresh: true,
						},
					})
				})

				// remove scrollbar panel,
				// when has gsap horizontal
				document.documentElement.classList.add('has-gsap-horizontal');
			}
		},5000);

		// Select All
		if (document.getElementById('check-all)')) {
			let checkAll = document.getElementById('checkAll')
			let otherCheckboxes = document.querySelectorAll('.form-group-checkbox input[type=checkbox]:not(#check-all)')

			checkAll.addEventListener('change', onCheckAllChange)
			otherCheckboxes.forEach(input => input.addEventListener('change', onOtherCheckboxChange))

			function onCheckAllChange() {
				otherCheckboxes.forEach((input) => input.checked = checkAll.checked)
			}

			function onOtherCheckboxChange() {
				let allChecked = Array.from(otherCheckboxes).every(input => input.checked);
				checkAll.checked = allChecked;
			}
		}

		function fixedWidth() {
			const chaffle = document.querySelectorAll("[data-chaffle]");

			chaffle.forEach((el) => {
				el.style.width = 'auto';
				let width = el.offsetWidth + 5;
				el.style.width = width + "px";
			});
		}

		setTimeout(function() {
			fixedWidth();
		},100);

		const elements = document.querySelectorAll("[data-chaffle]");
		Array.prototype.forEach.call(elements, function(el) {
			const chaffle = new Chaffle(el, {
				/* options */
			});
			el.addEventListener("mouseover", function() {
				chaffle.init();
			});
		});

		function updateLoco(){
			scroll.update();
		}

		// Scripts which runs at window resize
		window.addEventListener('resize', function(){
			updateLoco();
			setBodyClass();
			fixedWidth();

			if(document.querySelector('.course-accordion.active')) {
				const panel = document.querySelector('.course-accordion.active').nextElementSibling;
				panel.style.maxHeight = panel.scrollHeight + "px";
			}
		});

		// Scripts which runs at window orientationchange
		window.addEventListener('orientationchange', function() {
			setBodyClass();
			var rsContainer = document.querySelectorAll('.rs-container');

			rsContainer.forEach(function(el){
				el.remove();
			});
			setTimeout(function() {
				setHeight();
				loadMedia ();
				/*setSlider();*/
				fixedWidth();
			}, 10);

		});

		/**
		 * Sticky block in sidebar
		 */
		if (document.querySelector('.js-sticky-block')) {
			function getEnd() {
				const trigger = document.querySelector('.js-sticky-trigger');
				const sticky = document.querySelector('.js-sticky-block');
				const header = document.querySelector('.header');

				return trigger.offsetHeight - sticky.offsetHeight - ( (window.innerHeight - sticky.offsetHeight) / 2 ) + "px";
			}

			function getStart() {
				const header = document.querySelector('.header');

				return 0 - (header.offsetHeight + (window.innerHeight*0.005)) + "px";
			}

			// create
			let mm = gsap.matchMedia();
			let sidebarTween = null;

			mm.add("(min-width: 992px)", () => {
				sidebarTween = gsap.to(".js-sticky-block", {
					duration: 8,
					scrollTrigger: {
						trigger: ".js-sticky-block",
						scroller: '.wrapper',
						start: "center center",
						end: () => getEnd,
						scrub: 4,
						pin: ".js-sticky-block",
					}
				});
			});
		}
	}

	/* Marquee */
	function marqueeInit({ container, inner }) {
		document
			.querySelectorAll(container)
			.forEach((brandWrapper) => {
				if (brandWrapper.dataset.status === 'initialized') {
					return;
				}
				brandWrapper.dataset.status = 'initialized';

				const brandMarquee = brandWrapper.querySelector(inner);
				const brandMarqueeClone = brandMarquee.cloneNode(true);
				brandWrapper.appendChild(brandMarqueeClone);

				let rowLoad = performance.now();
				function marquee(rowX) {
					let rowStatus = (rowX - rowLoad) / 30000;
					if ( rowStatus > 1 ) {
						rowStatus %= 1;
						rowLoad = rowX;
					}
					let scrollLeft = brandMarquee.offsetWidth * rowStatus; // width row * status row
					brandMarquee.style.transform = 'translateX(-'+scrollLeft+'px)';
					brandMarqueeClone.style.transform = 'translateX(-'+scrollLeft+'px)';
					requestAnimationFrame(marquee);
				}
				requestAnimationFrame(marquee);
			});
	}

	function stopMatrixAnimations({ animations, targetClass, debug }) {
		// only for debug, can remove
		if (debug) {
			console.log(
				`Stopped ${targetClass || 'all matrix animations'} ${typeof debug === 'string' ? debug : ''}`
			)
		}

		// Turn off particular animation
		const index = animations.findIndex(a => a.$el.classList.contains(targetClass));

		if (index >= 0) {
			const { intervalId } = animations[index];
			clearInterval(intervalId);
			return;
		}

		// If no class provided or element not found
		// turn off all animations
		animations.forEach(a => {
			const { intervalId } = a;
			clearInterval(intervalId);
		});
	}

	// Parallax Images
	function initImageParallax() {

		// select all sections .with-parallax
		gsap.utils.toArray('.is-parallax').forEach(section => {

			// get the image
			const image = section.querySelector('img');

			// create tween for the image
			gsap.to(image, {
				scaleX: 1.2,
				scaleY:1.2,
				ease: 'power2.inOut',
				scrollTrigger: {
					trigger: section,
					scroller: '.wrapper',
					start: 'top bottom',
					scrub: true
				}
			});
		});
	}

	// Show/Hide Menu
	document.getElementById('openMenu').addEventListener('click', function (event) {
		if (body.classList.contains('opened-menu')) {
			body.classList.remove('opened-menu');
			body.classList.add('close-menu');
			setTimeout(function() {
				body.classList.remove('close-menu');
			}, 2000);
		}
		else {
			body.classList.add('opened-menu');
		}
		event.stopPropagation();
	});

	// Show/Hide Menu img
	var menuAllLink = selectAll('.main-menu > li > a, .menu-item-has-children a');
	var menuLink = selectAll('.main-menu > li > a');
	var childrenList = selectAll('.menu-item-has-children ul');

	menuLink.forEach((el) => {
		el.addEventListener("pointerenter",()=>{
			document.querySelector('.menu-item-has-children a').classList.remove('active');
		});
	});

	const headerNav = document.querySelector('.header-nav');
	let deviceDesktop = window.matchMedia("(min-width: 1200px)");
	if (deviceDesktop.matches) {
		menuAllLink.forEach((el) => {
			el.addEventListener("pointerenter",()=>{
				var text = (el.textContent + ' / ').repeat(20);
				var image;
				if ('img' in el.dataset) {
					url = el.dataset.img;
					image = new Image();
				} else if ('video' in el.dataset) {
					url = el.dataset.video;
					image = document.createElement("video");

				}
				image.src = url;
				image.classList.add('menu__media');
				headerNav.querySelector('.main-menu__img').appendChild(image);
				headerNav.querySelector('.main-menu__text-inner').innerText = text;
				headerNav.querySelector('.main-menu__img').classList.add('active');
				if ('video' in el.dataset) {
					image.play()
				}
				el.classList.add('active');
			});
			el.addEventListener("pointerleave",()=>{
				headerNav.querySelector('.menu__media').remove();
				headerNav.querySelector('.main-menu__text-inner').innerText = '';
				headerNav.querySelector('.main-menu__img').classList.remove('active');
			});
		});
	}

	childrenList.forEach((el) => {
		el.addEventListener("pointerleave",()=>{
			setTimeout(function() {
				headerNav.querySelector('.menu-item-has-children a').classList.remove('active');
			});
		});
	});

	function initShowHideHeader() {
		const header = select('.header');

		const showHeaderAnim = gsap.from(header, {
			yPercent: -100,
			paused: true,
			duration: 0.6
		}).progress(1);

		ScrollTrigger.create({
			scroller: scroller,
			start: 'top top',
			end: 99999,
			onUpdate: (self) => {
				self.direction === -1 ? showHeaderAnim.play() : showHeaderAnim.reverse();
			}
		});
	}

	function initCursor() {
		var targetNodes = document.querySelectorAll('a, button, .js-btn, .js-modal__close, .js-modal, .dignity__slider-head');
		var memberLink = selectAll('.team__member-button');
		var memberClose = selectAll('.full-modal__close');
		var magnets = document.querySelectorAll('.fly-btn');

		// clear all previously added event listeners
		if (cursorinner.dataset.status === 'initialized') {
			document.removeEventListener('mousemove', onDocumentMouseMove);
			document.removeEventListener('mousedown', onDocumentMouseDown);
			document.removeEventListener('mouseup', onDocumentMouseUp);

			targetNodes.forEach(el => {
				el.removeEventListener('mouseover', elMouseOver);
				el.removeEventListener('mouseleave', elMouseLeave);
			});

			memberLink.forEach(el => {
				el.removeEventListener('click', onMemberLinkClick);
			});

			memberClose.forEach(el => {
				el.removeEventListener('click', onMemberCloseClick);
			});

			magnets.forEach( (magnet) => {
				magnet.removeEventListener('mousemove', moveMagnet);
				magnet.removeEventListener('mouseout', magnetMouseOut);
			});
		} else {
			cursorinner.dataset.status = 'initialized';
		}

		function onDocumentMouseMove(e) {
			let x = e.clientX;
			let y = e.clientY;
			cursorinner.style.left = x + 'px';
			cursorinner.style.top = y + 'px';
		}
		document.addEventListener('mousemove', onDocumentMouseMove);

		function onDocumentMouseDown() {
			cursorinner.classList.add('cursorinnerhover')
		}
		document.addEventListener('mousedown', onDocumentMouseDown);

		function onDocumentMouseUp() {
			cursorinner.classList.remove('cursorinnerhover')
		}
		document.addEventListener('mouseup', onDocumentMouseUp);

		// onMouseOver/Leave
		function elMouseOver() {
			if ('cursor' in this.dataset) {
				cursorinner.classList.add('hover-text');
				cursorinner.innerHTML = this.dataset.cursor;
				let cursorBg = this.getAttribute('data-bg');
				let cursorColor = this.getAttribute('data-color');
				cursorinner.style.background = cursorBg;
				cursorinner.style.color = cursorColor;
			}
			else if ('tab' in this.dataset) {
				if (this.matches('.active')) {
					cursorinner.classList.add('hover-text','hover-text-minus');
				}
				else {
					cursorinner.classList.add('hover-text','hover-text-plus');
				}
			}
			else if ('link' in this.dataset) {
				cursorinner.classList.add('hover-text', 'hover-text-link');
			}
			else if ('close' in this.dataset) {
				cursorinner.classList.add('hover-text', 'hover-text-close');
			}
			else if ('view' in this.dataset) {
				cursorinner.classList.add('hover-text', 'hover-text-circle');
			}
			else {
				cursorinner.classList.add('hover');
			}
		}

		function elMouseLeave() {
			cursorinner.style.background = '';
			cursorinner.style.color = '';
			cursorinner.classList.remove('hover', 'hover-text', 'hover-text-plus', 'hover-text-minus', 'hover-text-link', 'hover-text-close', 'hover-text-circle');
			cursorinner.innerHTML = "";
		}

		targetNodes.forEach(el => {
			el.addEventListener('mouseover', elMouseOver);
			el.addEventListener('mouseleave', elMouseLeave);
		});

		// onMemberLinkClick
		function onMemberLinkClick() {
			cursorinner.innerHTML = "";
			cursorinner.classList.add('hover-text-close');
		}

		memberLink.forEach(el => {
			el.addEventListener('click', onMemberLinkClick);
		});

		// onMemberCloseClick
		function onMemberCloseClick() {
			cursorinner.classList.remove('hover', 'hover-text', 'hover-text-close');
			cursorinner.style.opacity = 0;
			setTimeout(function() {
				cursorinner.style.opacity = 1;
			},350);
		}

		memberClose.forEach(el => {
			el.addEventListener('click', onMemberCloseClick);
		});

		// Gravity links
		magnets.forEach( (magnet) => {
			magnet.addEventListener('mousemove', moveMagnet);
			magnet.addEventListener('mouseout', magnetMouseOut);
		});

		function moveMagnet(event) {
			let magnetButton = event.currentTarget
			let bounding = magnetButton.getBoundingClientRect()
			let strength = 50;

			TweenMax.to( magnetButton, 1, {
				x: ((( event.clientX - bounding.left)/magnetButton.offsetWidth) - 0.5) * strength,
				y: ((( event.clientY - bounding.top)/magnetButton.offsetHeight) - 0.5) * strength,
				ease: Power4.easeOut
			})
		}

		function magnetMouseOut(event) {
			TweenMax.to(event.currentTarget, 1, {x: 0, y: 0, ease: Power4.easeOut})
		}
	}

	function resetCursor(el, initialClass) {
		el.className = initialClass;
		el.textContent = '';
	}

	function setSlider(budgetSliderEl, timelineSliderEl) {
		if ( budgetSliderEl !== null ) {
			let idStr = budgetSliderEl.id;
			let valStr = (budgetSliderEl.value === '') ? 40 : +budgetSliderEl.value;
			let idStr2 = '#' + idStr;
			function setBudgetSlider() {
				new rSlider({
					target: idStr2,
					values: {min: 0, max: 350},
					range: false,
					tooltip: true,
					labels: false,
					step: 1,
					scale: false,
					set: [valStr],
				});
			}
			setBudgetSlider();
		}

		if ( timelineSliderEl !== null ) {
			let idStr = timelineSliderEl .id;
			let valStr = (timelineSliderEl.value === '') ? 15 : +timelineSliderEl.value;
			let idStr2 = '#' + idStr;
			function setTimelineSlider() {
				new rSlider({
					target: idStr2,
					values: {min: 0, max: 35},
					range: false,
					tooltip: true,
					labels: false,
					step: 1,
					scale: false,
					set: [valStr],
				});
			}
			setTimelineSlider();
		}
	}

	function setSliderCarrer() {
		let budgetSliderEl = document.querySelector('.budget-slider-career input');
		let timelineSliderEl  = document.querySelector('.timeline-slider-career input');

		setSlider(budgetSliderEl, timelineSliderEl);
	}

	function setSliderContact() {
		let budgetSliderEl = document.querySelector('.budget-slider input');
		let timelineSliderEl  = document.querySelector('.timeline-slider input');

		setSlider(budgetSliderEl, timelineSliderEl);
	}

	function initializeSliders() {
		let rsContainer = document.querySelectorAll('.rs-container');

		rsContainer.forEach(function(el) {
			el.remove();
		});

		setTimeout(function() {
			setSliderCarrer();
			setSliderContact();
		}, 10);
	}

	window.addEventListener('DOMContentLoaded', initializeSliders);
	window.addEventListener('orientationchange', initializeSliders);

	function get_works_more() {
		let $moreWorksBtn = document.getElementById('load-more-works');
		if ( $moreWorksBtn !== null ) {

			$moreWorksBtn.addEventListener('click', (e)=>{
				e.preventDefault();
				$moreWorksBtn.setAttribute("disabled", true);

				let loader = document.querySelector('.arrows-loader');
				loader.classList.remove('hidden');

				let offset = $moreWorksBtn.getAttribute('offset');
				let pageId = $moreWorksBtn.getAttribute('page-id');
				let $container = document.getElementById('works-items-container');

				if ( $container !== null ) {
					let formData        = new FormData();
					formData.append('action', 'get_more_works');
					formData.append('offset', offset);
					formData.append('page_id', pageId);
					formData.append('nonce', themeJsVars.nonce);

					fetch(themeJsVars.ajaxurl,{
						method: 'POST',
						body: formData,
						credentials: 'same-origin'
					})
					.then(response => response.json())
					.then(data => {
						if ( data.success ) {

							$moreWorksBtn.setAttribute('offset', data.offset);
							$container.insertAdjacentHTML('beforeend', data.html);
							// initPageTransitions();
							// ScrollTrigger.refresh();
							window.dispatchEvent(new Event('resize'));
							if (data.show_more !== 1) {
								$moreWorksBtn.style.display = 'none';
							}
							initCursor();
							marqueeInit({
								container: '.marquee__wrap',
								inner: '.marquee__inner'
							});
						} else {
							console.log(data);
						}
						$moreWorksBtn.setAttribute("disabled", false);
						loader.classList.add('hidden');
					})
					.catch(err => console.log(err));
				}
			});
		}
	}

	document.addEventListener('gform_post_render', function(event, form_id){
		if ( form_id === 2 ) {
			setSliderContact();
		}

		if ( form_id === 5 ) {
			setSliderCarrer();
		}
	});

	if (document.getElementById('dignity')) {
		let ipLink = select('.dignity__slider-head');
		let ipLinkH = ipLink.scrollHeight;
		let ipLinkW = ipLink.scrollWidth;

		let ipLinks = document.querySelectorAll('.dignity__slider-head');
		ipLinks.forEach((el) => {

			el.addEventListener("mousemove", moveImage);
		});


		function moveImage(e) {

			const rect = e.target.getBoundingClientRect();
			const xpos = ((e.clientX - rect.left)/ipLinkW*100) + "%";
			const ypos = ((e.clientY - rect.top)/ipLinkH*100) + "%";
			const tl = gsap.timeline();
			tl.to('.dignity__slider-title.double', {

				clipPath: "circle(8.333vw at "+xpos+" "+ypos+")"
			});
			tl.to('.circle', {
				left: xpos,
				top: ypos
			}, "<");
		}

	}
});
